<template>
  <div class="position">
    <div class="selector-container">
      <div class="selector-box">
        <div
          class="selector-carrier"
          @click.stop="isShowSelectorOptions = !isShowSelectorOptions"
        >
          <span>{{ checkedCurrency }}</span>
          <img
            :src="require('@/assets/images/arrow1.png')"
            :class="{ rotate: isShowSelectorOptions }"
          />
        </div>
        <transition name="fade">
          <div v-show="isShowSelectorOptions" class="selector-options">
            <div
              v-for="item in holdingData"
              :key="item.currencyName"
              class="option-item"
              :class="{ active: item.currencyName === checkedCurrency }"
              @click="checkedCurrency = item.currencyName"
            >
              {{ item.currencyName }}
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div class="stat-container">
      <div class="profit-box">
        <div class="profit-stat">
          <span>{{ `${$t('浮动总盈余')} (${checkedCurrency})` }}</span>
          <span>{{ totalFloatingPhase }}</span>
        </div>
        <div class="profit-chat"></div>
      </div>
      <div class="detail-box">
        <div v-for="item in detailItems" :key="item.label" class="detail-item">
          <div class="detail-item--label">
            <span>{{ item.label }}</span>
            <el-popover
              v-if="item.tips"
              placement="top"
              width="200"
              trigger="hover"
              popper-class="position-popper"
            >
              <img
                slot="reference"
                class="position-popper--reference"
                :src="require('@/assets/images/question.png')"
              />
              <div class="tips-title">{{ $t(item.tips[0]) }}</div>
              <div class="tips-content">{{ $t(item.tips[1]) }}</div>
            </el-popover>
          </div>
          <div v-if="item.key" class="detail-item--value">
            {{
              currencyHoldingData
                ? `${currencyHoldingData[item.key]}${
                    item.key === 'riskRatio' ? '%' : ''
                  }`
                : ''
            }}
          </div>
          <div v-else class="action">
            <span type="text" @click="$router.push('/history')">{{
              $t('历史记录')
            }}</span>
            <span type="text" @click="transferModalVisible = true">{{
              $t('划转')
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="data-container">
      <div class="data-tabs">
        <div
          v-for="item in tabs"
          :key="item.val"
          class="tab-item"
          :class="{ active: item.val === activeTab }"
        >
          <span @click="activeTab = item.val">{{ item.label }}</span>
        </div>
      </div>
      <PositionTable
        :list="positionsDataList"
        :columns="columns"
        :tableLoading="tableLoading"
        @modifyProfitAndLossPrice="modifyProfitAndLossPriceEvent"
        @closePositioin="closePositioinEvent"
        @oneClickClosePositioin="
          (rowData) => closePositioinEvent(rowData, true)
        "
      />
    </div>

    <!-- 修改止盈止损 modal -->
    <Modal
      v-model="dialogVisible"
      :title="$t('止盈止损')"
      width="388px"
      :closable="false"
      :mask-closable="false"
      class-name="common-modal"
      :before-close="() => (rowData = null)"
    >
      <template v-if="rowData">
        <div class="stop-item">
          <div class="input-box">
            <div class="label-text">{{ $t('止盈') }}</div>
            <input
              v-model="profitPrice"
              :placeholder="$t('请输入止盈价格')"
              @input="handleInput(profitPrice, 'profitPrice', 4)"
              @blur="!+profitPrice && (profitPrice = '')"
            />
          </div>
          <div class="price-value">
            <span>
              {{
                `${
                  { BULL: '&gt;', BEAR: '&lt;' }[rowData.direction]
                } ${profitPriceBasis}`
              }}
            </span>
            <span v-if="!!expectedProfit">
              {{ $t('预计盈利') }} {{ expectedProfit }}
            </span>
          </div>
        </div>
        <div class="stop-item">
          <div class="input-box">
            <div class="label-text">{{ $t('止损') }}</div>
            <input
              v-model="lossPrice"
              :placeholder="$t('请输入止损价格')"
              @input="handleInput(lossPrice, 'lossPrice', 4)"
              @blur="!+lossPrice && (lossPrice = '')"
            />
          </div>
          <div class="price-value">
            <span>
              {{
                `${
                  { BULL: '&lt;', BEAR: '&gt;' }[rowData.direction]
                } ${lossPriceBasis}`
              }}
            </span>
            <span v-if="!!expectedLoss">
              {{ $t('预计亏损') }} {{ expectedLoss }}
            </span>
          </div>
        </div>
        <span slot="footer">
          <Button type="text" @click="dialogVisible = false">
            {{ $t('取消') }}
          </Button>
          <Button
            type="primary"
            :loading="loading"
            @click="commitUpdateProfitAndLossPrice"
          >
            {{ $t('确认') }}
          </Button>
        </span>
      </template>
    </Modal>

    <!-- 划转 modal -->
    <TransferModal
      v-model="transferModalVisible"
      :coinsAsset="coinsAsset"
      :holdingData="holdingData"
      :initCurrency="checkedCurrency"
      @transferSucceed="transferSucceedEvent"
    />
  </div>
</template>
<script>
import TransferModal from '@/components/TransferModal'
import { mapState } from 'vuex'
import { sendWSPush, createSocket } from '@/utils/contractWebSocket'
import {
  fetchHoldingData,
  doUpdateProfitAndLossPrice,
  doClosePosition,
  doOneClickClosePosition,
} from '@/api/contract'
import { ajax_getMyAssetList } from '@/api/assets'
import { Big } from 'big.js'
import PositionTable from './components/PositionTable.vue'
import digitProcess from '@/mixin/digital-process'

export default {
  mixins: [digitProcess],
  components: {
    PositionTable,
    TransferModal,
  },
  data() {
    return {
      coinsAsset: [], // 币币资产
      transferModalVisible: false,
      loading: false,
      lossPrice: '',
      profitPrice: '',
      rowData: null,
      dialogVisible: false,
      holdingData: [],
      tableLoading: true,
      checkedCurrency: '',
      isShowSelectorOptions: false,
      detailItems: [
        { label: this.$t('余额'), key: 'balance' },
        { label: this.$t('净值'), key: 'netAssets' },
        {
          label: this.$t('风险率'),
          key: 'riskRatio',
          tips: [
            this.$t('风险率说明'),
            this.$t(
              '风险率是根据净值/累计占用保证金来计算的，所得值越大越安全。'
            ),
          ],
        },
        { label: this.$t('已用保证金'), key: 'used' },
        { label: this.$t('可用保证金'), key: 'available' },
        {
          label: this.$t('强平保证金'),
          key: 'strongParity',
          tips: [
            this.$t('强平保证金说明'),
            this.$t(
              '在正常交易中，需要保持的保证金水平，如果低于该水平将会被强制平仓。'
            ),
          ],
        },
        { label: this.$t('操作') },
      ],
      tabs: [
        { label: this.$t('订单'), val: 'order' },
        { label: this.$t('产品'), val: 'product' },
      ],
      activeTab: 'order',
    }
  },
  computed: {
    columns() {
      const actionColumn = {
        title: this.$t('操作'),
        renderType: 'slot',
        slot: 'action',
      }

      const prevCommonColumns = [
        {
          title: this.$t('类别'),
          renderType: 'slot',
          slot: 'category',
        },
        {
          title: this.$t('名称'),
          renderType: 'slot',
          slot: 'currency',
        },
        {
          title: this.$t('开仓价'),
          key: 'openPrice',
        },
        {
          title: this.$t('当前价'),
          key: 'currentPrice',
        },
        {
          title: this.$t('数量'),
          key: 'amount',
        },
        {
          renderType: 'slot',
          slot: 'profit',
          renderHeader: (h) => {
            return h('span', `${this.$t('浮动盈亏')}(${this.checkedCurrency})`)
          },
        },
        {
          title: this.$t('保证金'),
          key: 'initMargin',
        },
        {
          title: this.$t('止盈止损'),
          renderType: 'slot',
          slot: 'stop',
        },
      ]
      const orderColumns = [
        ...prevCommonColumns,
        {
          title: this.$t('过夜利息'),
          key: 'holdingFee',
        },
        {
          title: this.$t('手续费'),
          key: 'openCommissionFee',
        },
        {
          title: this.$t('订单号'),
          key: 'holdSn',
        },
        {
          title: this.$t('时间'),
          key: 'createdDate',
        },
        actionColumn,
      ]
      const productColumns = [
        {
          type: 'expand',
          width: 50,
          render: (h, { row }) => {
            return h(PositionTable, {
              props: {
                tableLoading: false,
                columns: orderColumns,
                list: row.positionData,
              },
              on: {
                modifyProfitAndLossPrice: this.modifyProfitAndLossPriceEvent,
                closePositioin: this.closePositioinEvent,
              },
            })
          },
        },
        ...prevCommonColumns,
        {
          title: this.$t('笔数'),
          key: 'num',
          render: (h, { row }) => {
            return h('span', `${row.num}${this.$t('笔')}`)
          },
        },
        actionColumn,
      ]

      return { order: orderColumns, product: productColumns }[this.activeTab]
    },
    ...mapState('contract', ['quotes']),
    currentPrice() {
      const quote = this.quotes.find(
        (item) => item.contractNo === this.rowData?.contractNo?.toUpperCase()
      )
      return quote?.price || ''
    },
    // 当前选中Curreny的持仓数据
    currencyHoldingData() {
      return this.holdingData.find(
        (item) => item.currencyName === this.checkedCurrency
      )
    },

    // 当前选中Curreny的持仓数据列表
    positionsDataList() {
      const positionsDataList = this.currencyHoldingData?.positionsDataList
      if (this.activeTab === 'order') {
        return positionsDataList
      } else {
        const dataMap = new Map()
        positionsDataList.forEach((item) => {
          const { contractNo, direction, lever } = item
          const key = `${contractNo.toUpperCase()}${direction}${lever}`
          const val = dataMap.get(key)
          if (val) {
            val.positionData.push(item)
            this.mergerPositionData(val, item, [
              'openPrice',
              'amount',
              'initMargin',
              'profitPrice',
              'lossPrice',
              'num',
            ])
          } else {
            dataMap.set(key, { ...item, positionData: [item], num: 1 })
          }
        })
        return [...dataMap.values()].map((item) => {
          item.openPrice = Big(item.openPrice).div(item.num).toString()
          return item
        })
      }
    },
    //  总浮动盈亏 = （当前价 - 开仓价）* 方向数字 * 合约单位 * 数量
    totalFloatingPhase() {
      if (!this.positionsDataList?.length || !this.quotes.length) return '0'

      return this.positionsDataList
        .reduce((calc, item) => {
          const quote = this.quotes.find(
            (_item) => _item.contractNo === item.contractNo.toUpperCase()
          )
          if (quote) {
            return Big(quote.price)
              .minus(item.openPrice)
              .mul(item.direction.toUpperCase() === 'BULL' ? 1 : -1)
              .mul(item.unit)
              .mul(item.amount)
              .plus(calc)
          }

          return calc
        }, Big(0))
        .toString()
    },
    // 止盈基准价
    profitPriceBasis() {
      if (!this.rowData || !this.currentPrice) return ''
      const { direction, openPrice } = this.rowData
      if (direction === 'BULL') {
        return this.currentPrice > openPrice ? this.currentPrice : openPrice
      } else {
        return this.currentPrice < openPrice ? this.currentPrice : openPrice
      }
    },
    // 止损基准价
    lossPriceBasis() {
      if (!this.rowData || !this.currentPrice) return ''
      const { direction, openPrice } = this.rowData
      if (direction === 'BULL') {
        return this.currentPrice > openPrice ? openPrice : this.currentPrice
      } else {
        return this.currentPrice < openPrice ? openPrice : this.currentPrice
      }
    },
    // 预计盈利
    expectedProfit() {
      return this.calculateExpected('profitPrice')
    },
    // 预计亏损
    expectedLoss() {
      return this.calculateExpected('lossPrice')
    },
  },
  mounted() {
    document.addEventListener('click', this.selectorHandler)
    createSocket(process.env.VUE_APP_CONTRACT_WS)
    if (!this.quotes.length) {
      sendWSPush({ channel: 'public', language: 'zh' })
    }
    this.getHoldingData()
    this.getCoinsAsset()
  },
  beforeDestroy() {
    document.removeEventListener('click', this.selectorHandler)
  },
  methods: {
    async getCoinsAsset() {
      const { item } = await ajax_getMyAssetList({
        start: 0,
        offset: 9999,
      })
      this.coinsAsset = item
    },
    /**
     * @description 划转成功刷新数据
     */
    transferSucceedEvent() {
      this.getHoldingData()
      this.getCoinsAsset()
    },
    /**
     * @description 合并持仓数据
     * @param mergeRet 合并结果
     * @param prositionItem 持仓数据项
     * @param fields 须合并字段
     */
    mergerPositionData(mergeRet, prositionItem, fields) {
      fields.forEach((item) => {
        if (item === 'num') {
          ++mergeRet[item]
        } else {
          mergeRet[item] = Big(+mergeRet[item] || 0)
            .plus(+prositionItem[item] || 0)
            .toString()
        }
      })
    },
    /**
     * @description 平仓
     * @param row 行数据
     * @param isOneClick 是否一键点击
     */
    async closePositioinEvent(row, isOneClick = false) {
      const titleText = this.$t('提示')
      const contentText = this.$t('确认平仓？')
      const okText = this.$t('确认')
      const cancelText = this.$t('取消')
      await this.$Modal.confirm({
        okText,
        cancelText,
        title: '',
        render(h) {
          return h('div', {}, [
            h(
              'div',
              {
                attrs: {
                  style:
                    'height:24px;line-height:24px;font-size:16px;color:rgba(0,0,0,0.9);font-weight:600;',
                },
              },
              titleText
            ),
            h(
              'div',
              {
                attrs: {
                  style:
                    'height:42px;line-height:42px;font-size:14px;color:rgba(0,0,0,0.6)',
                },
              },
              contentText
            ),
          ])
        },
        onOk: async () => {
          const { holdSn, currency, contractNo, direction, lever } = row
          const api = isOneClick ? doOneClickClosePosition : doClosePosition
          let params
          if (isOneClick) {
            params = {
              currency,
              contractNo,
              direction,
              lever,
            }
          } else {
            params = { holdSn }
          }
          await api(params)
          this.$Message.success(this.$t('操作成功'))
          this.getHoldingData()
        },
      })
    },
    /**
     * @description 提交更新止盈止损价格
     */
    async commitUpdateProfitAndLossPrice() {
      if (!+this.profitPrice) this.profitPrice = ''
      if (!+this.lossPrice) this.lossPrice = ''
      this.loading = true
      try {
        await doUpdateProfitAndLossPrice({
          orderSn: this.rowData.holdSn,
          profitPrice: this.profitPrice,
          lossPrice: this.lossPrice,
        })
        this.$Message.success(this.$t('操作成功'))
        this.getHoldingData()
        this.dialogVisible = false
      } finally {
        this.loading = false
      }
    },
    /**
     * @description 计算预计盈利&预计亏损
     * @param priceField 止盈止损价格字段
     *
     */
    calculateExpected(priceField) {
      const price = this[priceField]
      const priceBasis = {
        lossPrice: this.lossPriceBasis,
        profitPrice: this.profitPriceBasis,
      }[priceField]

      if (!+price || !+priceBasis || !this.rowData) return ''
      const { direction, amount, unit } = this.rowData

      let dValue
      if (
        (priceField === 'profitPrice' && direction === 'BULL') ||
        (priceField === 'lossPrice' && direction === 'BEAR')
      ) {
        dValue = Big(price).minus(priceBasis)
      } else {
        dValue = Big(priceBasis).minus(price)
      }

      if (dValue <= 0) {
        return ''
      }

      return dValue.mul(amount).mul(unit).toString()
    },
    // 修改止盈止损
    modifyProfitAndLossPriceEvent(rowData) {
      this.dialogVisible = true
      this.profitPrice = +rowData.profitPrice || ''
      this.lossPrice = +rowData.lossPrice || ''
      this.rowData = rowData
    },
    selectorHandler() {
      if (this.isShowSelectorOptions) {
        this.isShowSelectorOptions = false
      }
    },
    async getHoldingData() {
      this.tableLoading = true
      this.holdingData = await fetchHoldingData({ holdStatus: 'HOLDING' })
      if (this.holdingData.length && !this.checkedCurrency) {
        this.checkedCurrency = this.holdingData[0].currencyName
      }
      this.tableLoading = false
    },
  },
}
</script>
<style scoped lang="less">
.position {
  background: #000000;
  min-height: 100%;
  min-width: 1310px;
  .selector-container {
    height: 74px;
    display: flex;
    align-items: center;
    justify-content: center;
    .selector-box {
      position: relative;
      width: 294px;
      height: 54px;
      .selector-carrier {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 100%;
        padding-left: 35px;
        padding-right: 30px;
        background: #242b47;
        border-radius: 6px;
        cursor: pointer;
        img {
          transition: all 0.3s linear;
          width: 9px;
          height: 6px;
          &.rotate {
            transform: rotate(180deg);
          }
        }
        span {
          font-size: 14px;
          font-weight: bold;
          color: #ffffff;
          line-height: 24px;
        }
      }
      .fade-enter-active,
      .fade-leave-active {
        transition: opacity 0.5s;
      }
      .fade-enter, .fade-leave-to /* .fade-leave-active 在Vue 2.1.8+ 中 */ {
        opacity: 0;
      }
      .selector-options {
        cursor: pointer;
        position: absolute;
        bottom: -4px;
        transform: translateY(100%);
        padding: 10px 6px 6px;
        background: #ffffff;
        border-radius: 6px;
        box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.12),
          0px 4px 5px 0px rgba(0, 0, 0, 0.08),
          0px 1px 10px 0px rgba(0, 0, 0, 0.05);
        .option-item {
          padding-left: 8px;
          width: 282px;
          height: 32px;
          line-height: 32px;
          background: #f3f3f3;
          border-radius: 3px;

          font-size: 14px;
          font-weight: 500;
          color: #242b47;
          &:not(:last-child) {
            margin-bottom: 2px;
          }
          &.active {
            background: #e6eaf1;
          }
        }
      }
    }
  }
  .stat-container {
    height: 576px;
    background: #131625;
    padding: 10px 50px 54px;
    .profit-box {
      padding-top: 20px;
      padding-bottom: 26px;
      height: 283px;
      border: 1px solid #333646;
      border-radius: 4px 4px 0px 0px;
      .profit-stat {
        margin-bottom: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          &:first-child {
            margin-right: 44px;
            font-size: 16px;
            font-weight: 600;
            color: #8a91ab;
          }
          &:last-child {
            font-size: 36px;
            font-weight: bold;
            color: #ff3f4a;
          }
        }
      }
      .profit-chat {
        background: url('~@/assets/images/chat.png');
        background-size: cover;
        height: 136px;
      }
    }
    .detail-box {
      margin-top: 20px;
      height: 210px;
      background: rgba(22, 28, 61, 0.5);
      border-radius: 0px 0px 4px 4px;
      border: 1px solid #333646;
      display: flex;

      padding: 0 20px;
      .detail-item {
        flex: 1;
        padding: 55px 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        div {
          text-align: center;
          &.detail-item--label {
            span {
              &:first-child {
                font-size: 14px;
                font-weight: 600;
                color: rgba(210, 215, 236, 0.5);
              }
              &:nth-child(2) {
                margin-left: 5px;
              }
            }
            img {
              width: 16px;
              height: 16px;
            }
          }
          &.detail-item--value {
            font-size: 20px;
            font-weight: 600;
            color: #afb8de;
          }
          &.action {
            span {
              cursor: pointer;
              font-size: 16px;
              font-weight: bold;
              color: #3890f9;
              &:last-child {
                margin-left: 20px;
              }
            }
          }
        }
      }
    }
  }
  .data-container {
    margin-top: 10px;
    background: #101424;
    padding: 8px 50px 30px;
    .data-tabs {
      display: flex;
      margin-bottom: 40px;

      height: 64px;
      line-height: 64px;
      .tab-item {
        position: relative;
        font-size: 14px;
        font-weight: bold;
        color: #9b9fae;
        padding: 0 16px;
        span {
          cursor: pointer;
        }
        &:nth-child(1) {
          margin-right: 10px;
        }
        &.active {
          color: #ffffff;

          &::after {
            content: '';
            width: 100%;
            height: 4px;
            background: #c02e21;
            position: absolute;
            left: 0;
            bottom: 0;
          }
        }
      }
    }
  }
}
</style>
